import styled from 'styled-components';

export const BonusActivePanelUntilContentStyled = styled.div`
    color: var(--text-color-secondary);
    font-size: 10px;
    flex: 1 1 auto;
    display: flex;
    justify-content: ${({ flat }) => !!flat ? 'end' : 'start'};
    ${({ flat }) => !!flat && 'margin: 0 10px;'}
    
    b {
        font-weight: 600;
    }
`;
